import { Input, Label } from '@/components/ui'
import { WizardStep, WizardActions } from './WizardStep'

interface FamilyNameStepProps {
  familyName: string
  onFamilyNameChange: (name: string) => void
  onNext: () => void
  isValid: boolean
}

export function FamilyNameStep({
  familyName,
  onFamilyNameChange,
  onNext,
  isValid,
}: FamilyNameStepProps) {
  return (
    <WizardStep
      title="What should we call your family?"
      description="Pick something that feels like home"
    >
      <div className="space-y-4">
        <div>
          <Label htmlFor="familyName">Family Name</Label>
          <Input
            id="familyName"
            type="text"
            placeholder="e.g., The Smith Family"
            value={familyName}
            onChange={(e) => onFamilyNameChange(e.target.value)}
            className="mt-1"
            autoFocus
          />
          <p className="mt-1 text-xs text-gray-500">
            Everyone in your care circle will see this
          </p>
        </div>
      </div>

      <WizardActions
        onNext={onNext}
        isNextDisabled={!isValid}
        showBack={false}
      />
    </WizardStep>
  )
}
